'use client';

import NextLink from 'next/link';
import { type Ref } from 'react';

import { LinkProps } from '@/types/common';

type Props = LinkProps & { ref?: Ref<HTMLAnchorElement> };

const Link = ({
	ref,
	rel,
	href,
	style,
	target,
	className,
	children,
	onClick,
	onMouseEnter,
	onMouseLeave,
	onTouchStart,
	onTouchEnd,
	onTouchCancel,
	...rest
}: Props) => {
	const baseUri = process.env.NEXT_PUBLIC_WEBSITE_URL || '';
	const targetValue =
		(href?.startsWith('http') && !href.includes(baseUri)) || target === '_blank'
			? '_blank'
			: undefined;
	const hrefValue = href?.includes('@') && !href?.includes('http') ? `mailto:${href}` : href;

	return (
		<NextLink
			ref={ref}
			href={hrefValue}
			target={targetValue}
			style={style}
			className={className}
			rel={rel ? rel : targetValue ? 'noopener noreferrer' : undefined}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onTouchStart={onTouchStart}
			onTouchEnd={onTouchEnd}
			onTouchCancel={onTouchCancel}
			{...rest}
		>
			{children}
		</NextLink>
	);
};

export default Link;
